<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable persistent max-width="700px">
      <v-card>
        <v-card-title v-if="datastorage.user_name_en && $t('default') === 'en'">
          {{ $t("quota_storage.setting") }} <br v-if="resolutionScreen < 400"> {{ datastorage.user_name_en}}
          <v-spacer></v-spacer>
          <v-icon :color="color.theme" dense dark size="35">mdi-server</v-icon>
        </v-card-title>
        <v-card-title v-else-if="datastorage.user_name_th && $t('default') === 'th'">
          {{ $t("quota_storage.setting") }} <br v-if="resolutionScreen < 400"> {{ datastorage.user_name_th}}
          <v-spacer></v-spacer>
          <v-icon :color="color.theme" dense dark size="35">mdi-server</v-icon>
        </v-card-title>
        <v-card-title v-else-if="datastorage.department_name">
          {{ $t("quota_storage.setting") }} <br v-if="resolutionScreen < 400"> {{ datastorage.department_name}}
          <v-spacer></v-spacer>
          <v-icon :color="color.theme" dense dark size="35">mdi-server</v-icon>
        </v-card-title>
        <v-card-title v-else>
          {{ $t("quota_storage.headerset") }}
          <v-spacer></v-spacer>
          <v-icon :color="color.theme" dense dark size="35">mdi-server</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- จอคอม -->
          <div v-if="resolutionScreen >= 500">
            <v-card class=" mt-3 ml-10 mr-10 elevation-0">
              <v-card-title class="pb-0"
                ><v-icon class="pr-2">mdi-city</v-icon
                >{{ $t("quota_storage.quota_business") }}</v-card-title
              >
              <v-card-text class="pb-0 pt-2">
                <v-layout class="pl-16 pr-16 ml-16 mr-16 pt-0 pb-0 mt-0">
                  <div>
                    <v-progress-circular
                      v-if="percent_remain > 40"
                      :rotate="90"
                      :width="20"
                      :size="100"
                      :value="percent_remain"
                      color="light-green"
                      ><strong class="caption font-weight-light"
                        >{{ percent_remain }}%</strong
                      ></v-progress-circular
                    >
                    <v-progress-circular
                      v-else-if="percent_remain <= 40 && percent_remain > 10"
                      :rotate="90"
                      :width="20"
                      :size="100"
                      :value="percent_remain"
                      color="amber"
                      ><strong class="caption font-weight-light"
                        >{{ percent_remain }}%</strong
                      ></v-progress-circular
                    >
                    <v-progress-circular
                      v-else-if="percent_remain <= 10"
                      :rotate="90"
                      :width="20"
                      :size="100"
                      :value="percent_remain"
                      color="red"
                      ><strong class="caption font-weight-light"
                        >{{ percent_remain }}%</strong
                      ></v-progress-circular
                    >
                  </div>
                  <v-list two-line subheader>
                    <v-list-item class="pt-0">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="remain_business"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="$t('quota_storage.text_remain_bus')"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card class=" mt-0 ml-10 mr-10  elevation-0">
              <v-card-title class="pb-0"
                ><v-icon class="pr-2">mdi-account</v-icon
                >{{ $t("quota_storage.text_set_quota_head") }}</v-card-title
              >
              <v-card-text v-if="resolutionScreen >= 500">
                <!-- <br/> -->
                <v-layout class="pl-16 pr-16 ml-16 mr-16 ">
                  <v-list two-line subheader>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="quota_storage"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="$t('quota_storage.text_set_quota')"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-layout>
                <!-- <br /> -->
                <v-layout class="pl-16 pr-16 ml-16 mr-16 ">
                  <v-list two-line subheader>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="remain_storage"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="$t('quota_storage.text_remain')"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list two-line subheader>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="used_storage"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="$t('quota_storage.text_used')"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-layout>
                <!-- <br /> -->

                <!-- <v-layout class="pl-16 pr-16 ml-16 mr-16 "><v-text-field v-model="storan" label="ใส่ความจุที่ต้องการแก้ไข" dense outlined hide-details  type="number"></v-text-field>
              <v-select
              v-model="selectsize"
            :items="itemsize"       
            outlined
            dense
            ></v-select>
            </v-layout> -->
              </v-card-text>
            </v-card>
            <v-card class=" mt-3 ml-10 mr-10 mb-2 elevation-2">
              <v-card-title
                ><v-icon class="pr-2">settings</v-icon
                >{{ $t("quota_storage.setstorage") }}</v-card-title
              >
              <v-card-text>
                <!-- <br/> -->
                <v-layout class="pl-16 pr-16 ml-16 mr-16 "
                  ><v-text-field
                    v-model="edit_storage"
                    :label="$t('quota_storage.text_edit')"
                    dense
                    outlined
                    hide-details
                    type="number"
                    min="0"
                  ></v-text-field>
                  <v-select
                    v-model="selectsize"
                    :items="itemsize"
                    outlined
                    dense
                  ></v-select
                ></v-layout>
              </v-card-text>
            </v-card>
          </div>
          <!-- จอโทรศัพท์ -->
          <div v-else>
            <v-card class="elevation-0 ma-1">
              <v-card-title v-if="resolutionScreen < 400" class="pa-2 pt-4">
                <v-icon class="pr-2">mdi-city</v-icon>{{$t("quota_storage.quota_business")}}
              </v-card-title>
              <v-card-title v-else class="pb-0">
                <v-icon class="pr-2">mdi-city</v-icon>
                <span>{{$t("quota_storage.quota_business")}}</span>
              </v-card-title>
              <v-card-text class="mt-2 pa-0">
                <v-layout row wrap justify-center>
                  <v-flex sm6 xs5 class="text-right">
                    <v-progress-circular
                      v-if="percent_remain > 40"
                      :rotate="90"
                      :width="20"
                      :size="100"
                      :value="percent_remain"
                      color="light-green"
                    >
                      <strong class="caption font-weight-light">
                        {{ percent_remain }}%
                      </strong>
                    </v-progress-circular>
                    <v-progress-circular
                      v-else-if="percent_remain <= 40 && percent_remain > 10"
                      :rotate="90"
                      :width="20"
                      :size="100"
                      :value="percent_remain"
                      color="amber"
                      ><strong class="caption font-weight-light"
                        >{{ percent_remain }}%</strong
                      ></v-progress-circular
                    >
                    <v-progress-circular
                      v-else-if="percent_remain <= 10"
                      :rotate="90"
                      :width="20"
                      :size="100"
                      :value="percent_remain"
                      color="red"
                      ><strong class="caption font-weight-light"
                        >{{ percent_remain }}%</strong
                      ></v-progress-circular
                    >
                  </v-flex>
                  <v-flex sm6 xs7 class="text-left pt-4 pl-2">
                    <v-list-item-title
                      v-text="remain_business"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-text="$t('quota_storage.text_remain_bus')"
                    ></v-list-item-subtitle>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card class="elevation-0 ma-1">
              <v-card-title class="pa-2 pt-4"
                ><v-icon class="pr-2">mdi-account</v-icon>&nbsp;{{
                  $t("quota_storage.text_set_quota_head")
                }}</v-card-title
              >
              <v-card-text>
                <!-- <v-list two-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="quota_storage"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="$t('quota_storage.text_set_quota')"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-list two-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="remain_storage"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="$t('quota_storage.text_remain')"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-list two-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="used_storage"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="$t('quota_storage.text_used')"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list> -->
                <v-layout row wrap justify-center>
                    <v-list two-line subheader>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="quota_storage"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-text="$t('quota_storage.text_set_quota')"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-list two-line subheader>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="remain_storage"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-text="$t('quota_storage.text_remain')"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-list two-line subheader>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="used_storage"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-text="$t('quota_storage.text_used')"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card class="mt-0 ml-4 mr-4">
              <v-card-title
                ><v-icon class="pr-2">settings</v-icon>&nbsp;{{
                  $t("quota_storage.setstorage")
                }}</v-card-title
              >
              <v-card-text>
                <v-text-field
                  v-model="edit_storage"
                  :label="$t('quota_storage.text_edit')"
                  dense
                  outlined
                  hide-details
                  type="number"
                  min="0"
                ></v-text-field>
                <v-select
                  class="pt-1"
                  v-model="selectsize"
                  :items="itemsize"
                  outlined
                  dense
                ></v-select>
              </v-card-text>
              <br />
            </v-card>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()">{{
            $t("admin.close")
          }}</v-btn>
          <v-btn
            :color="color.theme"
            :dark="color.darkTheme"
            @click="fn_update_storge()"
            :loading="loadprogress"
            >{{ $t("admin.submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  mixins: [validationMixin],
  validations: {
    filename: { required },
  },
  props: ["show", "datastorage", "remain_business", "type", "percent_remain"],
  data: function() {
    return {
      loadprogress: false,
      selectsize: "GB",
      itemsize: ["KB", "MB", "GB", "TB"],
      quota_storage: "",
      remain_storage: "",
      used_storage: "",
      edit_storage: 0,
      storau: "1 GB",
      storan: 50,
      selectSize: "",
      filename: "",
      createprogress: false,
      zoom: 0,
      test: 1,
      unitremain: "",
      updatestorage: 0,
      maxstorage: 0,
      remain_storage: 0,
      sizeStorage: ["MB", "GB"],
      totalstorage: 0,
      unit_storage_account: "",
      plusnum: 1,
      maxstorageupdate: "",
    };
  },
  computed: {
    ...mapState(["username", "authorize", "account_active", "color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
    ]),
    shower: {
      get() {
        if (this.show === true) {
        }
        return this.show;
      },
      set(value) {
        if (!value) {
        }
      },
    },
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
  },
  watch: {
    show: function(val) {
      if (val === true) {
        console.log(this.datastorage, this.remain_business);
        this.quota_storage = this.datastorage["quota_storage"];
        this.remain_storage = this.datastorage["remain_storage"];
        this.used_storage = this.datastorage["used_storage"];
        this.convertstorage(this.datastorage.quota_storage);
      } else {
        //this.$emit("closemanagestorage");
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
      this.test = 1;
      this.loadprogress = false;
    },
    convertstorage(parameter) {
      let res_ = parameter.split(" ");
      this.edit_storage = parseFloat(res_[0]);
      this.selectsize = res_[1];
      console.log(this.edit_storage);
    },
    async fn_update_storge() {
      this.loadprogress = true;
      let id = [];
      let type = "";
      if (this.type === "de") {
        id.push(this.datastorage["department_id"]);
        type = "department";
      } else {
        id.push(this.datastorage["account_user"]);
        type = "employee";
      }
      console.log("id", id, this.edit_storage);
      var payload = {
        account_admin: this.dataAccountId,
        id: id,
        business_id: this.dataAccountActive.business_info.business_id,
        unit: this.selectsize,
        storage: this.edit_storage.toString(),
        type: type,
      };
      let auth = await gbfGenerate.generateToken();
      await this.axios
        .post(
          process.env.VUE_APP_SERVICE_ADMIN_BOX +
            "/api/admin/update_storage_emlpoyee_or_department",
          payload,
          { headers: { Authorization: auth.code } }
        )
        .then((response) => {
          console.log("file", response);

          if (response.data.status === "OK") {
            this.loadprogress = false;
            this.$emit("closemanagestorage");
            Toast.fire({
              icon: "success",
              // title: "ตั้งค่าสำเร็จ",
              title: this.$t("admintoast.settingsuccess")
            });
          } else if (errorMessage === "Not enough storage.") {
            this.loadprogress = false;
            Toast.fire({
              icon: "error",
              title: this.$t("admintoast.notenoughstorage")
            });
          } else {
            this.loadprogress = false;
            Toast.fire({
              icon: "error",
              // title:
              //   response.data.errorCode + ": " + response.data.errorMessage,
              title: this.$t("admintoast.errormanagequotastorage"),
            });
          }
        })
        .catch((error) => {
          this.loadprogress = false;
          Toast.fire({
            icon: "error",
            // title: error,
            title: this.$t("admintoast.errormanagequotastorage"),
          });
        });
    },
  },
};
</script>
<style></style>
